// crm namespace — Client Detail: header, actions, summary, consent, tabs.
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "actions.book": "Réserver une séance",
    "actions.log": "Noter un échange",
    "actions.notConsented": "Le client n'a pas donné son consentement",
    "actions.sendEmail": "Envoyer un e-mail",
    "assign.amount": "Montant",
    "assign.choose": "Choisissez un forfait",
    "assign.done": "Forfait attribué",
    "assign.empty": "Aucun forfait pour l'instant",
    "assign.emptyBody": "Les forfaits de séances arrivent avec Admin → CRM → Forfaits. Dès qu'il y en a un, vous pourrez l'attribuer ici.",
    "assign.markPaid": "Marquer payé",
    "assign.pack": "Forfait",
    "assign.payment": "Paiement",
    "assign.recordAmount": "Saisir un montant",
    "assign.submit": "Attribuer",
    "assign.title": "Attribuer un forfait · {name}",
    "consent.dataExport": "Exporter les données du client",
    "consent.none": "Aucun consentement enregistré. Il est donné en cochant un formulaire de contact.",
    "consent.source": "Source : {source}",
    "consent.title": "Consentement",
    "detail.addBirthday": "Ajouter l'anniversaire",
    "detail.addPhone": "Ajouter un téléphone",
    "detail.addTags": "Ajouter des étiquettes",
    "detail.back": "← Clients",
    "detail.birthday": "Anniversaire {date}",
    "detail.editHint": "Cliquez sur un champ pour le modifier",
    "detail.editName": "Modifier le nom",
    "detail.editTags": "Modifier les étiquettes",
    "detail.emailTaken": "Un autre client utilise déjà cette adresse.",
    "detail.summary": "Résumé",
    "detail.tab.emails": "E-mails",
    "detail.tab.notes": "Notes",
    "detail.tab.pathways": "Parcours",
    "detail.tab.purchases": "Achats",
    "detail.tab.sessionNotes": "Notes de séance",
    "detail.tab.sessions": "Séances",
    "detail.tab.timeline": "Historique",
    "detail.tabs": "Fiche client",
    "docs.attached": "Document joint",
    "docs.delete": "Supprimer le document",
    "docs.deleteTitle": "Supprimer ce document ?",
    "docs.download": "Télécharger",
    "docs.empty": "Aucun document pour l'instant.",
    "docs.title": "Documents",
    "docs.upload": "Téléverser",
    "email.body": "Message",
    "email.sent": "E-mail envoyé",
    "email.subject": "Objet",
    "email.title": "Écrire à {name}",
    "emails.empty": "Aucun e-mail envoyé pour l'instant",
    "emails.manual": "manuel",
    "emails.meta": "De {from} à {to} · {date}",
    "emails.viewTitle": "E-mail",
    "links.add": "+ {kind}",
    "links.course": "Cours",
    "links.empty": "Rien d'associé pour l'instant.",
    "links.none": "Rien à associer.",
    "links.pickTitle": "Associer : {kind}",
    "links.product": "Produit",
    "links.remove": "Retirer",
    "links.search": "Rechercher",
    "links.title": "Offres associées",
    "log.calendarFailed": "La synchronisation avec le calendrier a échoué.",
    "log.calendarNoConnection": "Google Agenda n'est pas connecté.",
    "log.calendarSynced": "Synchronisé avec Google Agenda.",
    "log.date": "Date",
    "log.done": "Terminé",
    "log.endTime": "Heure de fin",
    "log.placeholder": "Une ligne…",
    "log.save": "Ajouter à l'historique",
    "log.saved": "Ajouté à l'historique",
    "log.startTime": "Heure de début",
    "log.summary": "Résumé",
    "log.timeInvalid": "L'heure de fin doit être après l'heure de début.",
    "log.type": "Type d'échange",
    "merge.absorb": "Fusionnée dedans",
    "merge.confirm": "Confirmer la fusion",
    "merge.done": "Fiches fusionnées",
    "merge.keep": "Conservée",
    "merge.result": "Résultat",
    "merge.search": "Trouver l'autre fiche (3 caractères ou plus)",
    "merge.title": "Fusionner un doublon · aperçu côte à côte",
    "more.delete": "Supprimer le client",
    "more.erase": "Effacer les données du client",
    "more.header": "⋮ plus",
    "more.label": "Plus d'actions",
    "more.merge": "Fusionner un doublon",
    "more.ownerOnly": "(Titulaire uniquement)",
    "more.unsubscribe": "Désabonner le client",
    "notes.add": "Ajouter une note",
    "notes.added": "Note ajoutée",
    "notes.byline": "{who} · {date}",
    "notes.delete": "Supprimer la note",
    "notes.deleteTitle": "Supprimer cette note ?",
    "notes.edit": "Modifier la note",
    "notes.edited": "modifiée",
    "notes.empty": "Aucune note pour l'instant.",
    "notes.generalTitle": "Notes",
    "notes.intake": "Réponses d'accueil · lecture seule",
    "notes.intakeEmpty": "Aucun formulaire d'accueil rempli.",
    "notes.lastSaved": "Enregistrée le {date} · {who}",
    "notes.noSessions": "Aucune séance à laquelle rattacher une note.",
    "notes.pickSession": "Séance",
    "notes.placeholder": "Une note sur ce client (non clinique)…",
    "notes.sessionOption": "Séance : {date}, {service}",
    "notes.sessionPlaceholder": "Ce qui s'est passé, ce qu'il faut essayer la prochaine fois…",
    "notes.sessionSaved": "Note de séance enregistrée",
    "notes.sessionTitle": "Notes de séance (titulaire uniquement)",
    "pack.used": "{used} sur {total} utilisées",
    "pack.usedLeft": "{used} sur {total} utilisées · {left} restantes",
    "purchases.amount": "Montant",
    "purchases.date": "Date",
    "purchases.empty": "Aucun achat pour l'instant",
    "purchases.item": "Élément",
    "purchases.refunded": "{amount} remboursés",
    "purchases.status": "Statut",
    "purchases.type": "Type",
    "sessions.adjust": "Ajustement manuel",
    "sessions.adjustNote": "Note (facultative)",
    "sessions.adjustNotePlaceholder": "Motif de la correction…",
    "sessions.empty": "Aucune séance pour l'instant",
    "sessions.hiddenForHelper": "Contenu des notes masqué pour l'assistant",
    "sessions.minus": "Une séance utilisée de moins",
    "sessions.packDelta": "forfait {delta}",
    "sessions.plus": "Une séance utilisée de plus",
    "sessions.position": "{used} sur {total}",
    "sessions.void": "Annuler le forfait",
    "sessions.voidBody": "Le forfait \"{name}\" ({used} sur {total} utilisées) sera annulé pour ce client. Cette action ne touche ni Stripe ni la comptabilité — c'est une correction de fiche.",
    "sessions.voidConfirm": "Annuler le forfait",
    "sessions.voidDone": "Forfait annulé",
    "sessions.voidNote": "Note (facultative)",
    "sessions.voidTitle": "Annuler ce forfait ?",
    "stage.autoHint": "Définie automatiquement par les règles. En choisir une la fixe à la main.",
    "stage.change": "Changer l'étape",
    "stage.manualBadge": "{stage} · manuel",
    "stage.manualHint": "Fixée à la main : les règles ne touchent plus ce client.",
    "stage.resume": "Reprendre l'automatique",
    "summary.assignPack": "Attribuer un forfait",
    "summary.courses": "Cours détenus",
    "summary.memberSince": "Client depuis",
    "summary.pack": "Forfait en cours",
    "summary.products": "Produits achetés",
    "summary.sessions": "Séances",
    "summary.spend": "Dépenses totales",
    "summary.split": "({online} en ligne / {offline} en présentiel)",
    "sessions.logged": "noté : {who}, {when}",
  },
  en: {
    "actions.book": "Book session",
    "actions.log": "Log interaction",
    "actions.notConsented": "Client has not consented",
    "actions.sendEmail": "Send email",
    "assign.amount": "Amount",
    "assign.choose": "Choose a pack",
    "assign.done": "Pack assigned",
    "assign.empty": "No packs yet",
    "assign.emptyBody": "Session packs arrive with Admin → CRM → Packs. Once one exists, it can be assigned here.",
    "assign.markPaid": "Mark paid",
    "assign.pack": "Pack",
    "assign.payment": "Payment",
    "assign.recordAmount": "Record amount",
    "assign.submit": "Assign",
    "assign.title": "Assign pack · {name}",
    "consent.dataExport": "Client data export",
    "consent.none": "No consent recorded yet. It is given by ticking a capture form.",
    "consent.source": "Source: {source}",
    "consent.title": "Consent",
    "detail.addBirthday": "Add birthday",
    "detail.addPhone": "Add phone",
    "detail.addTags": "Add tags",
    "detail.back": "← Clients",
    "detail.birthday": "Birthday {date}",
    "detail.editHint": "Click any field to edit inline",
    "detail.editName": "Edit name",
    "detail.editTags": "Edit tags",
    "detail.emailTaken": "Another client already uses this email.",
    "detail.summary": "Summary",
    "detail.tab.emails": "Emails",
    "detail.tab.notes": "Notes",
    "detail.tab.pathways": "Pathways",
    "detail.tab.purchases": "Purchases",
    "detail.tab.sessionNotes": "Session notes",
    "detail.tab.sessions": "Sessions",
    "detail.tab.timeline": "Timeline",
    "detail.tabs": "Client record",
    "docs.attached": "Document attached",
    "docs.delete": "Delete document",
    "docs.deleteTitle": "Delete this document?",
    "docs.download": "Download",
    "docs.empty": "No documents yet.",
    "docs.title": "Documents",
    "docs.upload": "Upload",
    "email.body": "Message",
    "email.sent": "Email sent",
    "email.subject": "Subject",
    "email.title": "Email {name}",
    "emails.empty": "No emails sent yet",
    "emails.manual": "manual",
    "emails.meta": "From {from} to {to} · {date}",
    "emails.viewTitle": "Email",
    "links.add": "+ {kind}",
    "links.course": "Course",
    "links.empty": "Nothing attached yet.",
    "links.none": "Nothing to attach.",
    "links.pickTitle": "Attach: {kind}",
    "links.product": "Product",
    "links.remove": "Remove",
    "links.search": "Search",
    "links.title": "Attached offerings",
    "log.calendarFailed": "The calendar sync failed.",
    "log.calendarNoConnection": "Google Calendar is not connected.",
    "log.calendarSynced": "Synced to Google Calendar.",
    "log.date": "Date",
    "log.done": "Done",
    "log.endTime": "End time",
    "log.placeholder": "One line…",
    "log.save": "Save to timeline",
    "log.saved": "Saved to the timeline",
    "log.startTime": "Start time",
    "log.summary": "Summary",
    "log.timeInvalid": "End time must be after start time.",
    "log.type": "Interaction type",
    "merge.absorb": "Merged into it",
    "merge.confirm": "Confirm merge",
    "merge.done": "Records merged",
    "merge.keep": "Keeps",
    "merge.result": "Result",
    "merge.search": "Find the other record (3+ characters)",
    "merge.title": "Merge duplicate · side-by-side preview",
    "more.delete": "Delete client",
    "more.erase": "Erase client data",
    "more.header": "⋮ more",
    "more.label": "More actions",
    "more.merge": "Merge duplicate",
    "more.ownerOnly": "(Owner only)",
    "more.unsubscribe": "Unsubscribe client",
    "notes.add": "Add note",
    "notes.added": "Note added",
    "notes.byline": "{who} · {date}",
    "notes.delete": "Delete note",
    "notes.deleteTitle": "Delete this note?",
    "notes.edit": "Edit note",
    "notes.edited": "edited",
    "notes.empty": "No notes yet.",
    "notes.generalTitle": "Notes",
    "notes.intake": "Intake responses · read-only",
    "notes.intakeEmpty": "No intake form answered yet.",
    "notes.lastSaved": "Saved {date} · {who}",
    "notes.noSessions": "No session to attach a note to yet.",
    "notes.pickSession": "Session",
    "notes.placeholder": "A note about this client (not clinical)…",
    "notes.sessionOption": "Session: {date}, {service}",
    "notes.sessionPlaceholder": "What happened, what to try next time…",
    "notes.sessionSaved": "Session note saved",
    "notes.sessionTitle": "Session notes (Owner only)",
    "pack.used": "{used} of {total} used",
    "pack.usedLeft": "{used} of {total} used · {left} left",
    "purchases.amount": "Amount",
    "purchases.date": "Date",
    "purchases.empty": "No purchases yet",
    "purchases.item": "Item",
    "purchases.refunded": "{amount} refunded",
    "purchases.status": "Status",
    "purchases.type": "Type",
    "sessions.adjust": "Manual adjust",
    "sessions.adjustNote": "Note (optional)",
    "sessions.adjustNotePlaceholder": "Reason for the correction…",
    "sessions.empty": "No sessions yet",
    "sessions.hiddenForHelper": "Note content hidden for Helper",
    "sessions.minus": "One session fewer used",
    "sessions.packDelta": "pack {delta}",
    "sessions.plus": "One session more used",
    "sessions.position": "{used} of {total}",
    "sessions.void": "Void pack",
    "sessions.voidBody": "The \"{name}\" pack ({used} of {total} used) will be voided for this client. This never touches Stripe or the ledger — it is a record correction.",
    "sessions.voidConfirm": "Void pack",
    "sessions.voidDone": "Pack voided",
    "sessions.voidNote": "Note (optional)",
    "sessions.voidTitle": "Void this pack?",
    "stage.autoHint": "Set automatically by the stage rules. Choosing one sets it by hand.",
    "stage.change": "Change stage",
    "stage.manualBadge": "{stage} · manual",
    "stage.manualHint": "Set by hand: the stage rules leave this client alone.",
    "stage.resume": "Resume automatic",
    "summary.assignPack": "Assign pack",
    "summary.courses": "Courses owned",
    "summary.memberSince": "Member since",
    "summary.pack": "Active pack",
    "summary.products": "Products bought",
    "summary.sessions": "Sessions",
    "summary.spend": "Lifetime spend",
    "summary.split": "({online} online / {offline} offline)",
    "sessions.logged": "logged: {who}, {when}",
  },
  es: {
    "actions.book": "Reservar sesión",
    "actions.log": "Registrar interacción",
    "actions.notConsented": "El cliente no ha dado su consentimiento",
    "actions.sendEmail": "Enviar correo",
    "assign.amount": "Importe",
    "assign.choose": "Elige un bono",
    "assign.done": "Bono asignado",
    "assign.empty": "Aún no hay bonos",
    "assign.emptyBody": "Los bonos de sesiones llegan con Admin → CRM → Bonos. Cuando exista uno, podrás asignarlo aquí.",
    "assign.markPaid": "Marcar pagado",
    "assign.pack": "Bono",
    "assign.payment": "Pago",
    "assign.recordAmount": "Registrar importe",
    "assign.submit": "Asignar",
    "assign.title": "Asignar bono · {name}",
    "consent.dataExport": "Exportar los datos del cliente",
    "consent.none": "Aún no hay consentimiento. Se da marcando un formulario de captación.",
    "consent.source": "Origen: {source}",
    "consent.title": "Consentimiento",
    "detail.addBirthday": "Añadir cumpleaños",
    "detail.addPhone": "Añadir teléfono",
    "detail.addTags": "Añadir etiquetas",
    "detail.back": "← Clientes",
    "detail.birthday": "Cumpleaños {date}",
    "detail.editHint": "Haz clic en un campo para editarlo",
    "detail.editName": "Editar el nombre",
    "detail.editTags": "Editar etiquetas",
    "detail.emailTaken": "Otro cliente ya usa este correo.",
    "detail.summary": "Resumen",
    "detail.tab.emails": "Correos",
    "detail.tab.notes": "Notas",
    "detail.tab.pathways": "Itinerarios",
    "detail.tab.purchases": "Compras",
    "detail.tab.sessionNotes": "Notas de sesión",
    "detail.tab.sessions": "Sesiones",
    "detail.tab.timeline": "Historial",
    "detail.tabs": "Ficha del cliente",
    "docs.attached": "Documento adjuntado",
    "docs.delete": "Eliminar el documento",
    "docs.deleteTitle": "¿Eliminar este documento?",
    "docs.download": "Descargar",
    "docs.empty": "Aún no hay documentos.",
    "docs.title": "Documentos",
    "docs.upload": "Subir",
    "email.body": "Mensaje",
    "email.sent": "Correo enviado",
    "email.subject": "Asunto",
    "email.title": "Escribir a {name}",
    "emails.empty": "Aún no se ha enviado ningún correo",
    "emails.manual": "manual",
    "emails.meta": "De {from} a {to} · {date}",
    "emails.viewTitle": "Correo",
    "links.add": "+ {kind}",
    "links.course": "Curso",
    "links.empty": "Aún no hay nada vinculado.",
    "links.none": "Nada que vincular.",
    "links.pickTitle": "Vincular: {kind}",
    "links.product": "Producto",
    "links.remove": "Quitar",
    "links.search": "Buscar",
    "links.title": "Ofertas vinculadas",
    "log.calendarFailed": "No se pudo sincronizar con el calendario.",
    "log.calendarNoConnection": "Google Calendar no está conectado.",
    "log.calendarSynced": "Sincronizado con Google Calendar.",
    "log.date": "Fecha",
    "log.done": "Listo",
    "log.endTime": "Hora de fin",
    "log.placeholder": "Una línea…",
    "log.save": "Guardar en el historial",
    "log.saved": "Guardado en el historial",
    "log.startTime": "Hora de inicio",
    "log.summary": "Resumen",
    "log.timeInvalid": "La hora de fin debe ser posterior a la hora de inicio.",
    "log.type": "Tipo de interacción",
    "merge.absorb": "Se fusiona",
    "merge.confirm": "Confirmar fusión",
    "merge.done": "Fichas fusionadas",
    "merge.keep": "Se conserva",
    "merge.result": "Resultado",
    "merge.search": "Buscar la otra ficha (3 caracteres o más)",
    "merge.title": "Fusionar duplicado · vista comparada",
    "more.delete": "Eliminar cliente",
    "more.erase": "Borrar los datos del cliente",
    "more.header": "⋮ más",
    "more.label": "Más acciones",
    "more.merge": "Fusionar duplicado",
    "more.ownerOnly": "(Solo titular)",
    "more.unsubscribe": "Dar de baja al cliente",
    "notes.add": "Añadir nota",
    "notes.added": "Nota añadida",
    "notes.byline": "{who} · {date}",
    "notes.delete": "Eliminar la nota",
    "notes.deleteTitle": "¿Eliminar esta nota?",
    "notes.edit": "Editar la nota",
    "notes.edited": "editada",
    "notes.empty": "Aún no hay notas.",
    "notes.generalTitle": "Notas",
    "notes.intake": "Respuestas de admisión · solo lectura",
    "notes.intakeEmpty": "Aún no hay formulario de admisión.",
    "notes.lastSaved": "Guardada el {date} · {who}",
    "notes.noSessions": "Aún no hay sesiones a las que añadir una nota.",
    "notes.pickSession": "Sesión",
    "notes.placeholder": "Una nota sobre este cliente (no clínica)…",
    "notes.sessionOption": "Sesión: {date}, {service}",
    "notes.sessionPlaceholder": "Qué pasó, qué probar la próxima vez…",
    "notes.sessionSaved": "Nota de sesión guardada",
    "notes.sessionTitle": "Notas de sesión (solo titular)",
    "pack.used": "{used} de {total} usadas",
    "pack.usedLeft": "{used} de {total} usadas · quedan {left}",
    "purchases.amount": "Importe",
    "purchases.date": "Fecha",
    "purchases.empty": "Aún no hay compras",
    "purchases.item": "Elemento",
    "purchases.refunded": "{amount} reembolsados",
    "purchases.status": "Estado",
    "purchases.type": "Tipo",
    "sessions.adjust": "Ajuste manual",
    "sessions.adjustNote": "Nota (opcional)",
    "sessions.adjustNotePlaceholder": "Motivo de la corrección…",
    "sessions.empty": "Aún no hay sesiones",
    "sessions.hiddenForHelper": "Contenido de las notas oculto para el asistente",
    "sessions.minus": "Una sesión usada menos",
    "sessions.packDelta": "bono {delta}",
    "sessions.plus": "Una sesión usada más",
    "sessions.position": "{used} de {total}",
    "sessions.void": "Anular el bono",
    "sessions.voidBody": "El bono \"{name}\" ({used} de {total} usadas) se anulará para este cliente. Esto no afecta a Stripe ni a la contabilidad: es una corrección de la ficha.",
    "sessions.voidConfirm": "Anular el bono",
    "sessions.voidDone": "Bono anulado",
    "sessions.voidNote": "Nota (opcional)",
    "sessions.voidTitle": "¿Anular este bono?",
    "stage.autoHint": "La fijan las reglas automáticamente. Elegir una la fija a mano.",
    "stage.change": "Cambiar etapa",
    "stage.manualBadge": "{stage} · manual",
    "stage.manualHint": "Fijada a mano: las reglas no tocan a este cliente.",
    "stage.resume": "Reanudar automático",
    "summary.assignPack": "Asignar bono",
    "summary.courses": "Cursos adquiridos",
    "summary.memberSince": "Cliente desde",
    "summary.pack": "Bono activo",
    "summary.products": "Productos comprados",
    "summary.sessions": "Sesiones",
    "summary.spend": "Gasto total",
    "summary.split": "({online} en línea / {offline} presenciales)",
    "sessions.logged": "registrado: {who}, {when}",
  },
};
